module.exports = __webpack_public_path__ + "img/accessory_hat_08.3a9ad467.svg";